import React, { useState } from 'react'

const InputDobOrAge = ({ dob, age, onChange, dobSize, ageSize }) => {
    const [isDobDisabled, setIsDobDisabled] = useState(false);
    const [isAgeDisabled, setIsAgeDisabled] = useState(false);
    const calculateAgeFromDob = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let years = today.getFullYear() - birthDate.getFullYear();
        let months = today.getMonth() - birthDate.getMonth();
        let days = today.getDate() - birthDate.getDate();
        if (days < 0) {
            months -= 1;
            days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
        }
        if (months < 0) {
            years -= 1;
            months += 12;
        }
        return { year: years, month: months, day: days };
    };
    function calculateDobFromAge(age) {
        const today = new Date();
        if (isNaN(today.getTime())) return "";
        today.setFullYear(today.getFullYear() - age.year || 0);
        today.setMonth(today.getMonth() - age.month || 0);
        today.setDate(today.getDate() - age.day || 0);
        return today.toISOString().split("T")[0];
    }
    const handleDobChange = (e) => {
        const dobValue = e.target.value;
        const calculatedAge = calculateAgeFromDob(dobValue);
        onChange({
            dob: dobValue,
            age: calculatedAge,
        });
        setIsAgeDisabled(true);
        setIsDobDisabled(false);
    };
    const handleAgeChange = (e) => {
        const { name, value } = e.target;
        const updatedAge = { ...age, [name]: Number(value) || 0 };
        onChange({
            dob: calculateDobFromAge(updatedAge),
            age: updatedAge,
        });
        setIsDobDisabled(true);
        setIsAgeDisabled(false);
    };
    return (
        <>
            <div className={dobSize ? dobSize : "col-xl-6"}>
                <div className="form-group position-relative">
                    <label htmlFor="age" className="col-form-label">Date of Birth:</label>
                    <input
                        name="dob"
                        type="date"
                        className="form-control"
                        value={dob}
                        onChange={handleDobChange}
                        disabled={isDobDisabled}
                    />
                </div>
            </div>
            <div className={ageSize ? ageSize : "col-xl-6"}>
                <div className="form-group position-relative">
                    <label htmlFor="age" className="col-form-label">Age:</label>
                    <div className="d-flex">
                        <div className="mr-2">
                            <input
                                type="number"
                                className="form-control"
                                id="age-year"
                                name="year"
                                placeholder="Years"
                                onChange={handleAgeChange}
                                disabled={isAgeDisabled}
                                value={age?.year || ""}
                            />
                        </div>
                        <div className="mr-2">
                            <input
                                type="number"
                                className="form-control"
                                id="age-month"
                                name="month"
                                value={age?.month || ""}
                                placeholder="Months"
                                onChange={handleAgeChange}
                                disabled={isAgeDisabled}
                            />
                        </div>
                        <div>
                            <input
                                type="number"
                                className="form-control"
                                id="age-day"
                                name="day"
                                value={age?.day || ""}
                                placeholder="Days"
                                onChange={handleAgeChange}
                                disabled={isAgeDisabled}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InputDobOrAge